export const INIT_GIFT_CARDS = 'INIT_GIFT_CARDS';

export const LIST_GIFT_CARDS = 'LIST_GIFT_CARDS';
export const LIST_GIFT_CARDS_SUCCESS = 'LIST_GIFT_CARDS_SUCCESS';
export const LIST_GIFT_CARDS_FAILED = 'LIST_GIFT_CARDS_FAILED';

export const SYNC_SHOPIFY_GIFT_CARDS = 'SYNC_SHOPIFY_GIFT_CARDS';
